import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Badge } from "react-bootstrap";

const Acasa = () => {
  const [comenzi, setComenzi] = useState([]);
  const [filtruIncomplete, setFiltruIncomplete] = useState(false);

  const citescComenzi = async () => {
    const obPromise = await fetch("/comenzi");
    const lista = await obPromise.json();
    setComenzi(lista);
  };

  useEffect(() => {
    citescComenzi();
  }, []);

  useEffect(() => {
    const interval = setInterval(citescComenzi, 5000);
    return () => clearInterval(interval);
  }, []);

  const nrDoc = (c) => {
    let nr = 0;
    if (c.factura?.numar) nr++;
    if (c.uit?.cod) nr++;
    if (c.cmr?.numar) nr++;
    if (c.declaratie?.semnat === "da") nr++;
    return nr;
  };

  const nrTotale = comenzi.length;
  const valoareTotala = comenzi.reduce(
    (suma, c) => suma + Number(c.valoare || 0),
    0,
  );
  const dosareComplete = comenzi.filter((c) => nrDoc(c) === 4).length;
  const dosareIncomplete = nrTotale - dosareComplete;

  return (
    <>
      <h2 className="mb-4">Dashboard Fenestra ERP</h2>
      <Row className="mb-4">
        <Col md={3} sm={6} className="mb-3">
          <Card className="text-center p-3 bg-primary text-white">
            <h1>{nrTotale}</h1>
            <p>Comenzi totale</p>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="text-center p-3 bg-success text-white">
            <h1>{dosareComplete}</h1>
            <p>Dosare complete TVA 0%</p>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card
            className="text-center p-3 bg-warning"
            style={{ cursor: "pointer" }}
            onClick={() => setFiltruIncomplete(!filtruIncomplete)}
          >
            <h1>{dosareIncomplete}</h1>
            <p>Dosare incomplete {filtruIncomplete ? "▲" : ""}</p>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="text-center p-3 bg-info text-white">
            <h1>{valoareTotala.toFixed(0)}</h1>
            <p>Valoare totala EUR</p>
          </Card>
        </Col>
      </Row>

      <h5>Toate comenzile</h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Client</th>
            <th>Tara</th>
            <th>Valoare EUR</th>
            <th>Data</th>
            <th>Dosar</th>
          </tr>
        </thead>
        <tbody>
          {(filtruIncomplete
            ? comenzi.filter((c) => nrDoc(c) < 4)
            : comenzi
          ).map((c) => (
            <tr key={c.id}>
              <td>{c.client}</td>
              <td>{c.tara}</td>
              <td>{c.valoare}</td>
              <td>{c.data_comanda}</td>
              <td>
                <Badge
                  bg={
                    nrDoc(c) === 4
                      ? "success"
                      : nrDoc(c) > 0
                        ? "warning"
                        : "danger"
                  }
                >
                  {nrDoc(c)}/4
                </Badge>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default Acasa;
